import { useTheme } from '@mui/material';

import { useConfig, Stack, useDeviceType } from '@packages/shared';
import { Joe, PaybackColored32 } from '@packages/themes/icons';

import { Slot } from './Slot';
import { AccountSlot } from './AccountSlot';
import { BasketSlot } from './BasketSlot';
import { SearchSlot } from './SearchSlot';
import { WishlistSlot } from './WishlistSlot';
import { WarehouseSlot } from './WarehouseSlot';
import { ServiceSlot } from './ServiceSlot';
import { LocaleSwitchSlot } from './LocaleSwitchSlot';

export const Slots = () => {
  const {
    headerSlots: { payback, localeSwitcher, warehouse, joe, serviceApi },
  } = useConfig();
  const { isMobile } = useDeviceType();
  const theme = useTheme();

  return (
    <Stack data-testid="header-slots" direction="row" spacing={[1.5, 1.5, 1.5, 3]}>
      {localeSwitcher && (
        // workaround: legacy fragment-header used a confusing mess of nth selectors and overrides
        // proper solution needs UI layout redesign
        <LocaleSwitchSlot sx={{ [theme.breakpoints.down(420)]: { display: 'none' } }} />
      )}
      {payback && (
        <Slot
          href="/service-hilfe/bestellen-beraten/payback/"
          icon={<PaybackColored32 />}
          title="Payback"
        />
      )}
      {joe && <Slot href="/service-hilfe/joe-bonus-club" title="Bonus Club" icon={<Joe />} />}
      {!isMobile && serviceApi && <ServiceSlot />}
      {/* workaround: legacy fragment-header used (max-width: 374px) with inverted logic */}
      {/* proper solution needs UI layout redesign */}
      <AccountSlot sx={{ [theme.breakpoints.down(375)]: { display: 'none' } }} />
      {warehouse && <WarehouseSlot />}
      <SearchSlot />
      <WishlistSlot />
      <BasketSlot />
    </Stack>
  );
};
